export default __webpack_public_path__ + "images/e6ce926c4e402287e29c4f8e2b83514f-EE_SlideDeckBOOK1024_14.png";